import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, CircularProgress, Box, Paper } from '@mui/material';
import PageAnimation from './animations/PageAnimation'; // Assuming PageAnimation is reusable

/**
 * This page handles the "magic link" login.
 * It reads the JWT from the URL, saves it to localStorage,
 * and redirects the user to their /order page, effectively logging them in.
 */
function MagicLoginPage() {
    const { token } = useParams(); // Gets the ':token' part from the URL
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            // 1. Set the token in localStorage, just like LoginPage.js does
            localStorage.setItem('accessToken', token);
            
            // 2. Dispatch the 'storage' event to update other components (e.g., Navbar)
            window.dispatchEvent(new Event('storage'));
            
            // 3. Redirect to the /order page as requested
            // 'replace: true' prevents the user from clicking "back" to this page
            navigate('/order', { replace: true });

        } else {
            // If no token is found for some reason, just send to normal login
            navigate('/login', { replace: true });
        }
    }, [token, navigate]); // This effect runs once when the component loads

    // Show a loading indicator while the redirect is happening
    return (
        <PageAnimation>
            <Container maxWidth="xs">
                <Paper elevation={6} sx={{ mt: 8, p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 2, color: "#75a84b" }}>
                    <CircularProgress sx={{ color: "#75a84b", mb: 2 }} />
                    <Typography component="h1" variant="h5">
                        Signing In...
                    </Typography>
                </Paper>
            </Container>
        </PageAnimation>
    );
}

export default MagicLoginPage;